<template>
  <div id="app">
    <Loading v-if="loadingDefaultPage"></Loading>
    <div ref="appHeader" id="header" class="navbar navbar-default navbar-static-top">
      <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar"
            aria-expanded="false" aria-controls="navbar">
            <span class="sr-only">{{ $t('layouts.toogle_button') }}</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link class="navbar-brand logo" :to="{ name: 'home' }">
            <img src="../assets/img/logo-blanco.svg" height="100%"/>
          </router-link>
        </div>
        <div id="navbar" class="navbar-collapse collapse" v-if="routesAssignedsInfo">
          <ul class="nav navbar-nav" v-if="routesAssignedsInfo !== 'public'">
            <menu-option v-for="menuOption in menuOptions" :key="menuOption.name" :menuOption="menuOption"></menu-option>
          </ul>
          <ul class="nav navbar-nav" v-if="isSupplier">
            <li data-v-69d37cc8="" class="dropdown">
              <a data-v-69d37cc8="" id="supplier-portals" href="#" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="true" class="dropdown-toggle">
                    {{ $t('layouts.portals') }} <span data-v-69d37cc8="" class="caret"></span>
              </a>
              <ul data-v-69d37cc8="" class="dropdown-menu">
                <li data-v-69d37cc8="" class="el-tooltip item" aria-describedby="el-tooltip-96" tabindex="0" v-for="portal in userPortals" :key="portal.id">
                  <a data-v-69d37cc8="" :href="portal.Url" target="_blank">{{ portal.DisplayName ? portal.DisplayName : portal.Name }}</a>
                </li>
              </ul>
            </li>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <li v-if="$route.name === 'cat4mro.catalog.search' || $route.name === 'cat4mro.shoppingcart'">
              <router-link v-if="counterInfo > 0" :to="{ name: 'cat4mro.shoppingcart' }">
                <span class="glyphicon glyphicon-shopping-cart"></span>
                <span class="label label-danger"> {{counterInfo}}</span>
              </router-link>
            </li>
            <li class="lang-dropdown">
              <div style="margin-top: 5px;margin-right: 5px;">
                <multiselect v-model="value" :options="options" :searchable="false" :close-on-select="true" :show-labels="false" :allow-empty="false" @select="dispatchAction"></multiselect>
              </div>
            </li>
            <li class="dropdown" v-if="currentUser">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                {{ currentUser.preferred_username }}
                <div class="divNotification hideIfOpened" v-if="showRedGlobeNotification">
                  <p class="numberNotification">1</p>
                </div>
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li>
                  <router-link :to="{ name: 'account' }">
                    {{ $t('layouts.nav_bar_options.account') }}
                    <div class="divNotification" v-if="showRedGlobeNotification">
                      <p class="numberNotification">1</p>
                    </div>
                  </router-link>
                </li>
                <li v-if="isSupplierAdmin">
                  <router-link :to="toOrganizationRoute">
                    {{ $t('layouts.nav_bar_options.organization') }}
                  </router-link>
                </li>
                <li v-if="isSupplierAdmin">
                  <router-link :to="{ name: 'supplier-admin.manage-users'}">
                    {{ $t('layouts.nav_bar_options.manageUsers') }}
                  </router-link>
                </li>
                <li class="divider"></li>
                <li><a href="#" @click="logout">{{ $t('layouts.nav_bar_options.logout') }}</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="el-backtop" v-show="backToTopIsVisible" style="right: 25px; bottom: 40px;" @click="handleBackToTop">
        <i class="fa fa-chevron-up"></i>
      </div>
    </div>
    <div class="container" :class="layoutOptions.containerClass">
      <div class="row" id="breadcrumbs">
        <div class="col-xs-12">
          <breadcrumbs />
        </div>
      </div>
      <div class="row" id="welcome">
        <div class="col-xs-12" v-if="!isCataloger">
          <div class="alert alert-info m10top" role="alert" v-if="currentUserProfileInfo && currentUserProfileInfo.organization">
            <p>
              {{ $t('layouts.welcome_alert.p1') }}<strong>{{ currentUserProfileInfo.fullName }}</strong>{{ $t('layouts.welcome_alert.p2') }}
              <strong>{{ currentUserProfileInfo.organization.name }}</strong>
              <a v-if="isBuyer(currentUserRoleInfo)" href="https://unilinkintegrations.blob.core.windows.net/cfa-files/cat4mro/Manual_Comprador_CAT4MRO_v1.pdf" target="_blank" style="top:-10px" class="pull-right"><i class="fa fa-question-circle"></i></a>
            </p>
            <p v-if="welcomeAlert" class="m10top">
              <span v-html="welcomeAlert"></span>
            </p>
          </div>
        </div>
      </div>
      <br>
      <div ref="appContent" class="row" id="content" :class="layoutOptions.contentClass">
        <router-view />
      </div>
    </div>
    <footer id="footer" class="footer text-center">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
          <b>
            <p>© <a href="https://www.unilinkcorp.com/" target="_blank" class="ref-footer">{{ $t('layouts.footer') }}</a></p>
          </b>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import map from 'lodash/map';
import isNil from 'lodash/isNil';
import filter from 'lodash/filter';
import MenuOption from '@/components/menu';
import Multiselect from 'vue-multiselect';
import Loading from '@/components/common/Loading';

/**
 * @param {Array} routes - The routes from vue router assigned
 * @description
 * This function is used to get the user based on the path (supplier, buyer or cataloger).
 * @example
 * typeOfUser(routes);
 * @returns {string} The user type
 */
function typeOfUser(routes) {
  const users = [
    { type: "supplier", path: "/dashboard" },
    { type: "buyer", path: "/cat4mro" },
    { type: "cataloger", path: "/materials" },
  ];
  const indexOfUser = users.findIndex(user =>
    routes.some(route => route.path === user.path),
  );
  const userType = users[indexOfUser].type || "";
  return userType;
}

export default {
  components: {
    MenuOption,
    Multiselect,
    Loading,
  },
  data() {
    return {
      value: null,
      options: ['English', 'Spanish'],
      routes: [],
      backToTopIsVisible: false,
      isUserDropdownOpened: false,
    };
  },
  computed: {
    ...mapState('dashboard', [
      'userPortals',
    ]),
    ...mapState('auth', [
      'loadingDefaultPage',
    ]),
    ...mapGetters('shoppingCart', [
      'counterInfo',
    ]),
    ...mapGetters('auth', [
      'currentUser',
      'currentUserProfileInfo',
      'currentUserRoleInfo',
      'routesAssignedsInfo',
      'currentRoutesInfo',
    ]),
    ...mapState('auth', ['allowedRoles']),
    ...mapState('termsAndConditions', ['showRedGlobeNotification']),
    menuOptions() {
      const routes = filter(
        this.currentRoutesInfo,
        route => route.meta && route.meta.menuOptions,
      );
      const userType = typeOfUser(routes);
      const retVal = map(routes, route => ({
        name: route.name,
        path: route.path,
        title: this.title(userType, route.name, 'title'),
        description: this.title(userType, route.name, 'description'),
        children: map(filter(route.children, routechildren => routechildren.meta && routechildren.meta.menuOptions), routeChildren => ({
          name: routeChildren.name,
          path: routeChildren.path,
          title: this.title(userType, routeChildren.path, 'title'),
          description: this.title(userType, routeChildren.path, 'description'),
        })),
      }));
      return retVal;
    },
    layoutOptions() {
      return this.$route.meta.layoutOptions || { contentClass: 'content' };
    },
    welcomeAlert() {
      return this.$route.meta.welcomeAlert || '';
    },
    toOrganizationRoute() {
      if (isNil(this.currentUserProfileInfo) || isNil(this.currentUserProfileInfo.organization)) {
        return {};
      }
      return { name: 'supplier-admin.manage-organization', params: { organization: this.currentUserProfileInfo.organization.id } };
    },
    isCataloger() {
      return this.$route.fullPath.includes('materials');
    },
    isSupplier() {
      const rol = this.currentUserRoleInfo;
      return rol === 'mro_supplier' || rol === 'mro_manage_supplier' || rol === 'supplier';
    },
    isSupplierAdmin() {
      return this.currentUserRoleInfo === 'mro_manage_supplier';
    },
  },
  mounted() {
    const $ = window.jQuery;
    window.addEventListener('scroll', this.handleBackToTopVisibility);
    window.jQuery(document).ready(() => {
      function autoHeight() {
        $('#content').css('min-height', 0);
        $('#content').css('min-height', (
          // eslint-disable-next-line no-mixed-operators
          ($(document).height() - $('#header').height() - $('#footer').height() - $('#breadcrumbs').height() - $('#welcome').height())
        ));
      }

      $(document).ready(() => {
        autoHeight();
      });

      $(window).resize(() => {
        autoHeight();
      });

      autoHeight();
    });
    this.value = this.$store.getters['language/getAppLanguage'] === 'en-US' ? 'English' : 'Spanish';
  },
  methods: {
    logout() {
      this.$store.dispatch('auth/logout');
    },
    handleBackToTopVisibility() {
      if (this.$refs.appContent) {
        const element = this.$refs.appHeader;
        const offset = window.jQuery(element).offset().top - window.jQuery(window).scrollTop();

        if (offset < (window.innerHeight - 1500)) {
          this.backToTopIsVisible = true;
        } else {
          this.backToTopIsVisible = false;
        }
      }

      return false;
    },
    handleBackToTop() {
      this.handleScrollTop('#header');
    },
    handleScrollTop(element) {
      window.jQuery([document.documentElement, document.body]).animate({
        scrollTop: window.jQuery(element).offset().top,
      }, 1000);
    },
    isBuyer(rol) {
      return rol === 'mro_buyer' || rol === 'buyer';
    },
    dispatchAction(language) {
      if (language === 'English') {
        this.$store.commit('language/setAppLanguage', 'en-US');
        this.$i18n.locale = 'en-US';
      } else if (language === 'Spanish') {
        this.$store.commit('language/setAppLanguage', 'es');
        this.$i18n.locale = 'es';
      }
    },
    /**
     * @param {string} userType - 'buyer' or 'supplier' (A 'cataloger' role should be implemented)
     * @param {string} name - The name of the route
     * @param {string} text - The text to be translated
     * @returns {string} The translated text
     * @description
     * This function is used to get the title of the route based on the language
     * @example
     * this.title('buyer', 'supplier-admin.manage-organization', 'title');
     *
     */
    title(userType, name, text) {
      return !this.$i18n.te(`routes.${userType}.${name}.${text}`) ? null : this.$i18n.t(`routes.${userType}.${name}.${text}`);
    },
  },
};
</script>

<style>
.lang-dropdown {
  min-width: 100px;
}
.el-backtop {
      position: fixed;
      background-color: #fff;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      color: #001c34;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      box-shadow: 0 0 6px rgba(0,0,0,.12);
      cursor: pointer;
      z-index: 5;
  }
.footer {
    position: unset !important;
}
  .v-step {
    z-index: 9999;
    background: #fff !important;
    max-width: 400px !important;
    color: #091c34 !important;
  }
  .v-step__button {
    font-size: 12px !important;
    padding: 4px !important;
    background: #c34e5d !important;
    border: .05rem solid #c34e5d !important;
    color: #fff !important;
  }
  .v-step__arrow {
    border-color: #fff !important;
  }
  .ref-footer {
    color: white !important;
}
  .footer{
    background-color: #001c34;
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
}
footer p{
  color:white;
}
.logo{
  padding: 0.75rem;
}
.navbar-brand {
  padding: 8px 15px 8px 20px;
}
.divNotification {
  background-color: #bb4c5b;
  color: #fff;
  display: inline-flex;
  width: 1.5rem;
  height: 1.5rem;
  justify-content: center;
  font-weight: 600;
  border-radius: 1rem;
}
.numberNotification {
  margin: 0;
  padding-top: 1px;
  font-size: 1rem;
  align-self: center;
}
li.dropdown > a[aria-expanded="true"] > div.hideIfOpened{
  display: none;
}
@media (min-width: 768px) {
    .dropdown-toggle {
      background: #001c34!important;
  }
  .dropdown-toggle:focus, .dropdown-toggle:hover{
    font-size: 15px;
    font-weight: 900;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Default.vue